import { queryOptions } from '@tanstack/react-query';
import { sidebarQueryFunction } from '@/modules/Dashboard/queries/sidebar/sidebarQueryFunction.ts';

export const sidebarQueryOptions = queryOptions({
  queryKey: ['sidebar'],
  queryFn: sidebarQueryFunction,
  select: (data) => ({
    firstName: data.first_name,
    lastName: data.last_name,
    fullName: `${data.first_name} ${data.last_name}`,
    wallet: data.wallet,
    point: data.point,
    performance_score: data.performance_score,
  }),
});
